var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.valueWithCommas,
        expression: "valueWithCommas",
      },
    ],
    staticClass: "form-control",
    class: _vm.classProp,
    attrs: { min: _vm.min, type: "text" },
    domProps: { value: _vm.valueWithCommas },
    on: {
      input: function ($event) {
        if ($event.target.composing) return
        _vm.valueWithCommas = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }